/* eslint-disable jsx-a11y/click-events-have-key-events, jsx-a11y/no-static-element-interactions*/

import React, { Component } from "react"
import Components from "../index"
import * as Icon from "react-feather"

import { blokType } from "../../types"

export interface FooterGroupProps {
  title: string
  items: blokType[]
}

interface FooterGroupState {
  displayGroup: boolean
}

export class FooterGroupCmp extends Component<
  FooterGroupProps,
  FooterGroupState
> {
  state = {
    displayGroup: false,
  }

  toggleGroup = () => {
    const { displayGroup } = this.state

    this.setState({
      displayGroup: !displayGroup,
    })
  }

  render() {
    const { displayGroup } = this.state
    const { title, items } = this.props

    return (
      <div className="footer-group">
        {title && (
          <header onClick={this.toggleGroup} className="footer-group__header">
            <p className="footer-group__title">{title}</p>
            <div className="footer-group__icon">
              {!displayGroup ? (
                <Icon.Plus className="icon icon--sm" />
              ) : (
                <Icon.Minus className="icon icon--sm" />
              )}
            </div>
          </header>
        )}
        {items && (
          <div
            className={`footer-group__items ${
              displayGroup ? "footer-group__items--visible" : ""
            }`}
          >
            {items &&
              items.map((c) =>
                React.createElement(Components(c.component), {
                  key: c._uid,
                  blok: c,
                  className: "footer-group__link",
                })
              )}
          </div>
        )}
      </div>
    )
  }
}
